/**
 * @generated SignedSource<<5e12a0b5b339081c09ca9382d0bca7aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DownloadExpenseInvoicePdfInput = {
  id: string;
};
export type IncomingInvoiceViewDownloadPdfMutation$variables = {
  input: DownloadExpenseInvoicePdfInput;
};
export type IncomingInvoiceViewDownloadPdfMutation$data = {
  readonly downloadExpenseInvoicePdf: {
    readonly filename: string;
    readonly uri: string;
  } | null | undefined;
};
export type IncomingInvoiceViewDownloadPdfMutation = {
  response: IncomingInvoiceViewDownloadPdfMutation$data;
  variables: IncomingInvoiceViewDownloadPdfMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TemporaryDownload",
    "kind": "LinkedField",
    "name": "downloadExpenseInvoicePdf",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uri",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "filename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IncomingInvoiceViewDownloadPdfMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IncomingInvoiceViewDownloadPdfMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "530d32c38e7edd833c0dd1a3a8bf8a5f",
    "id": null,
    "metadata": {},
    "name": "IncomingInvoiceViewDownloadPdfMutation",
    "operationKind": "mutation",
    "text": "mutation IncomingInvoiceViewDownloadPdfMutation(\n  $input: DownloadExpenseInvoicePdfInput!\n) {\n  downloadExpenseInvoicePdf(input: $input) {\n    uri\n    filename\n  }\n}\n"
  }
};
})();

(node as any).hash = "6fb6317b1e1dca843a7949e5e532ee38";

export default node;
